<div class="multi-select-wrapper">
  <label *ngIf="label" [for]="id || name" class="multi-select-label">
    {{ label }}
    <span *ngIf="required" class="required">*</span>
  </label>

  <div class="multi-select-container">
    <div class="multi-select-dropdown">
      <div
        class="multi-select-trigger"
        [class.has-error]="hasError"
        [class.disabled]="disabled"
        (click)="toggleDropdown($event)"
        tabindex="0"
        (keydown.enter)="toggleDropdown($event)"
        (keydown.space)="toggleDropdown($event)"
        [style.background-color]="disabled ? '#f7fafc' : 'white'">
        <span *ngIf="value.length === 0" class="placeholder-text">{{ placeholder }}</span>
        <ng-container *ngIf="value.length > 0">
          <span *ngIf="value.length === 1" class="selected-text">
            {{ value.length }} {{ 'pages.multiSelect.itemSelected' | transloco }}
          </span>
          <span *ngIf="value.length >= 2 && value.length <= 4" class="selected-text">
            {{ value.length }} {{ 'pages.multiSelect.itemsSelectedBelow5' | transloco }}
          </span>
          <span *ngIf="value.length >= 5" class="selected-text">
            {{ value.length }} {{ 'pages.multiSelect.itemsSelectedAbove5' | transloco }}
          </span>
        </ng-container>
        <i class="fas fa-chevron-down dropdown-arrow" [class.rotated]="isDropdownOpen"></i>
      </div>

      <div *ngIf="isDropdownOpen" class="multi-select-options" [class.multi-select-options--tall]="height === 'tall'">
        <div *ngFor="let option of options" class="option-item" (click)="toggleOption(option.value, $event)">
          <input type="checkbox" [checked]="isSelected(option.value)" [disabled]="disabled" readonly />
          <span class="option-label">
            {{ useTranslationForLabels ? (option.label | transloco) : option.label }}
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="value.length > 0" class="selected-display">
      <ng-container *ngIf="value.length <= showCountAfter">
        <span *ngIf="value.length === 1">
          {{ value.length }} {{ 'pages.multiSelect.itemSelected' | transloco }}
        </span>
        <span *ngIf="value.length >= 2 && value.length <= 4">
          {{ value.length }} {{ 'pages.multiSelect.itemsSelectedBelow5' | transloco }}
        </span>
        <span *ngIf="value.length >= 5">
          {{ value.length }} {{ 'pages.multiSelect.itemsSelectedAbove5' | transloco }}
        </span>
      </ng-container>

      <ng-container *ngIf="value.length > showCountAfter">
        <span *ngIf="value.length === 1">
          {{ value.length }} {{ 'pages.multiSelect.itemSelected' | transloco }}:
        </span>
        <span *ngIf="value.length >= 2 && value.length <= 4">
          {{ value.length }} {{ 'pages.multiSelect.itemsSelectedBelow5' | transloco }}:
        </span>
        <span *ngIf="value.length >= 5">
          {{ value.length }} {{ 'pages.multiSelect.itemsSelectedAbove5' | transloco }}:
        </span>
        <ng-container *ngFor="let label of (value | multiSelectLabels: options); let i = index">
          <span *ngIf="useTranslationForLabels">{{ label | transloco }}<span *ngIf="i < value.length - 1">, </span></span>
          <span *ngIf="!useTranslationForLabels">{{ label }}<span *ngIf="i < value.length - 1">, </span></span>
        </ng-container>
      </ng-container>
    </div>

    <div *ngIf="placeholder && value.length === 0" class="placeholder-hint">
      {{ placeholder }}
    </div>
  </div>

  <div *ngIf="hasError" class="error-message">
    {{ errorMsg }}
  </div>
</div>
